const HUALONG_HUB_URL = 'https://h5-hualong.vdvq.com/#/trace?product=5'
const HUALONG_HOSTNAME = 'h5-hualong.vdvq.com'
const HUALONG_STORAGE_KEY = 'hualong:last-product-id'

const PRODUCT_DEFINITIONS = [
  {
    legacyId: 35,
    name: '净酸菜',
    spec: '238g',
    keywords: '华龙 酸菜 袋装',
    testUuid: '32951447b99111efb01800163e0c6a17',
    prodUuid: '32951447-b991-4a49-be62-24675aeab77a'
  },
  {
    legacyId: 36,
    name: '酸菜脆笋',
    spec: '80g',
    keywords: '华龙 脆笋 袋装',
    testUuid: 'f28ecbe601bf11f0b01800163e0c6a17',
    prodUuid: 'f28ecbe6-01bf-49e2-8066-f760b1bc83b5'
  },
  {
    legacyId: 37,
    name: '酸菜香菇原味',
    spec: '80g',
    keywords: '华龙 香菇 原味 袋装',
    testUuid: '22b0d7653302110fb01800163e0c6a17',
    prodUuid: '22b0d765-3302-4076-94b2-a32f55c7768b'
  },
  {
    legacyId: 38,
    name: '酸菜牛肉酱香辣',
    spec: '80g',
    keywords: '华龙 牛肉酱 香辣 袋装',
    testUuid: '35809ac6afa811efb01800163e0c6a17',
    prodUuid: '35809ac6-afa8-46f0-a6b8-c62a4fc3f316'
  },
  {
    legacyId: 39,
    name: '酸菜牛肉酱原味',
    spec: '80g',
    keywords: '华龙 牛肉酱 原味 袋装',
    testUuid: '210a751fab9711efb01800163e0c6a17',
    prodUuid: '210a751f-ab97-45ac-ad19-7253af046a84'
  },
  {
    legacyId: 40,
    name: '酸菜香菇牛肉酱原味',
    spec: '80g / 袋',
    keywords: '华龙 香菇 牛肉酱 原味 袋装',
    testUuid: '66150aef0b6c11f0b01800163e0c6a17',
    prodUuid: '66150aef-0b6c-4087-b179-7678303b6831'
  },
  {
    legacyId: 41,
    name: '酸菜牛肉酱香辣',
    spec: '230g / 瓶',
    keywords: '华龙 牛肉酱 香辣 瓶装',
    testUuid: '0f2ba887948c11f0b01800163e0c6a17',
    prodUuid: '0f2ba887-948c-4464-92f2-7689413f7f56'
  },
  {
    legacyId: 42,
    name: '酸菜牛肉酱原味',
    spec: '230g / 瓶',
    keywords: '华龙 牛肉酱 原味 瓶装',
    testUuid: '77456726c5c011efb01800163e0c6a17',
    prodUuid: '77456726-c5c0-4b3c-9802-0905cd615382'
  }
]

const GOODS_ID_MAP = {
  test: { 1213: 35, 1214: 36, 1215: 37, 1216: 38, 1217: 39, 1218: 40, 1219: 41, 1220: 42 },
  prod: { 1895: 35, 1896: 36, 1897: 37, 1898: 38, 1899: 39, 1900: 40, 1901: 41, 1902: 42 }
}

const HUALONG_HUB_GOODS_IDS = {
  test: new Set([1213, 1214, 1215, 1216, 1217, 1218, 1219, 1220]),
  prod: new Set([
    1904, 1905, 1906, 1907, 1908, 1909,
    1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921,
    1936, 1937, 1938
  ])
}

function getHualongEnv(envValue) {
  return envValue === 'test' ? 'test' : 'prod'
}

function getHualongProducts(envValue) {
  const env = getHualongEnv(envValue)
  return PRODUCT_DEFINITIONS.map(product => ({
    legacyId: product.legacyId,
    name: product.name,
    spec: product.spec,
    keywords: product.keywords,
    uuid: env === 'test' ? product.testUuid : product.prodUuid
  }))
}

function getHualongTeamId(envValue) {
  return getHualongEnv(envValue) === 'test' ? 39 : 46
}

function normalizeHualongProducts(rows) {
  if (!Array.isArray(rows)) return []
  return rows
    .filter(row => row && row.id)
    .map(row => ({
      legacyId: null,
      goodsId: Number(row.goods_id) || 0,
      name: row.name || '未命名产品',
      spec: row.spec || '',
      keywords: row.goods_id ? String(row.goods_id) : '',
      uuid: row.id
    }))
}

function filterHualongHubProducts(products, envValue) {
  if (!Array.isArray(products)) return []
  const allowedGoodsIds = HUALONG_HUB_GOODS_IDS[getHualongEnv(envValue)]
  return products.filter(product => allowedGoodsIds.has(Number(product.goodsId)))
}

function findBatchIndex(batchList, latestBatch) {
  const index = (Array.isArray(batchList) ? batchList : [])
    .findIndex(item => item && String(item.batch) === String(latestBatch))
  return index >= 0 ? index : null
}

function isHualongTeam(teamId, envValue) {
  const expectedTeamId = getHualongEnv(envValue) === 'test' ? 39 : 46
  return Number(teamId) === expectedTeamId
}

function getHashParams(hash) {
  const query = String(hash || '').split('?')[1] || ''
  return new URLSearchParams(query)
}

function isHualongHub(hash) {
  const params = getHashParams(hash)
  return params.get('product') === '5'
}

function filterHualongProducts(products, keyword) {
  const normalized = String(keyword || '').trim().toLowerCase()
  if (!normalized) return products.slice()
  return products.filter(product =>
    [product.name, product.spec, product.keywords, product.legacyId]
      .join(' ')
      .toLowerCase()
      .includes(normalized)
  )
}

function resolveStoredProduct(products, storedLegacyId) {
  return products.find(product => product.uuid === storedLegacyId) ||
    products.find(product => product.legacyId !== null && product.legacyId === Number(storedLegacyId)) ||
    null
}

function readStoredProduct(storage, products) {
  try {
    return resolveStoredProduct(products, storage && storage.getItem(HUALONG_STORAGE_KEY))
  } catch (error) {
    return resolveStoredProduct(products, null)
  }
}

function writeStoredProduct(storage, product) {
  try {
    if (storage && product) storage.setItem(HUALONG_STORAGE_KEY, product.uuid)
  } catch (error) {
    // Storage can be unavailable in private browsing. Selection still works in memory.
  }
}

function shouldRedirectToHualong({ teamId, env, hostname, hash }) {
  if (!isHualongTeam(teamId, env)) return false
  if (String(hostname || '').toLowerCase() === HUALONG_HOSTNAME) return false
  return !isHualongHub(hash)
}

function shouldRedirectHubToHualong(hostname, hash) {
  return isHualongHub(hash) && String(hostname || '').toLowerCase() !== HUALONG_HOSTNAME
}

function parseProductIdFromHash(hash, envValue) {
  const params = getHashParams(hash)
  const productId = params.get('product_id')
  const product = params.get('product')
  if (productId) return { paramName: 'product_id', paramValue: productId }
  if (!product) return null

  const env = getHualongEnv(envValue)
  const products = getHualongProducts(env)
  const numericProduct = Number(product)
  const legacyId = GOODS_ID_MAP[env][numericProduct] || numericProduct
  const mappedProduct = products.find(item => item.legacyId === legacyId)
  return {
    paramName: 'product_id',
    paramValue: mappedProduct ? mappedProduct.uuid : product
  }
}

module.exports = {
  HUALONG_HUB_URL,
  HUALONG_HOSTNAME,
  HUALONG_STORAGE_KEY,
  getHualongEnv,
  getHualongProducts,
  getHualongTeamId,
  normalizeHualongProducts,
  filterHualongHubProducts,
  findBatchIndex,
  isHualongTeam,
  isHualongHub,
  filterHualongProducts,
  resolveStoredProduct,
  readStoredProduct,
  writeStoredProduct,
  shouldRedirectToHualong,
  shouldRedirectHubToHualong,
  parseProductIdFromHash
}
